module.exports = __webpack_public_path__ + "img/headuser.d24a0014.png";